/**
 * SaveAsTemplateModal — salva o quadro atual de um projeto como template custom.
 *
 * Captura colunas (stages) + tarefas atuais do projeto num molde reutilizável
 * (pjSaveProjectAsTemplate). Opções: incluir tarefas atuais como semente e
 * compartilhar com a organização.
 */

import { useState } from 'react'
import { useApp } from '../../context/AppContext.jsx'
import { pjSaveProjectAsTemplate } from '../../db/api.js'

export default function SaveAsTemplateModal({ project, onClose, onSaved }) {
  const { toast } = useApp()
  const [label, setLabel] = useState(project?.nome ? `${project.nome} (template)` : '')
  const [descricao, setDescricao] = useState('')
  const [includeTasks, setIncludeTasks] = useState(true)
  const [isShared, setIsShared] = useState(false)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  const submit = async () => {
    if (!label.trim() || saving) return
    setSaving(true); setErr(null)
    try {
      await pjSaveProjectAsTemplate(project.id, {
        label: label.trim(), descricao: descricao.trim() || null,
        include_tasks: includeTasks, is_shared: isShared,
      })
      toast('Template salvo.', 'success')
      onSaved?.()
    } catch (e) { setErr(e.message); setSaving(false) }
  }

  return (
    <div style={S.overlay} onMouseDown={onClose}>
      <div style={S.box} onMouseDown={(e) => e.stopPropagation()}>
        <div style={S.head}>
          <h4 style={S.title}>Salvar como template</h4>
          <button style={S.x} onClick={onClose}>×</button>
        </div>
        {err && <div style={S.error}>{err}</div>}

        <label style={S.miniLabel}>Nome do template</label>
        <input style={S.input} value={label} autoFocus onChange={(e) => setLabel(e.target.value)} />

        <label style={S.miniLabel}>Descrição (opcional)</label>
        <input style={S.input} value={descricao} onChange={(e) => setDescricao(e.target.value)} />

        <label style={S.checkRow}>
          <input style={S.checkbox} type="checkbox" checked={includeTasks} onChange={(e) => setIncludeTasks(e.target.checked)} />
          <span>Incluir as tarefas atuais como tarefas-semente</span>
        </label>
        <label style={S.checkRow}>
          <input style={S.checkbox} type="checkbox" checked={isShared} onChange={(e) => setIsShared(e.target.checked)} />
          <span>Compartilhar com toda a organização</span>
        </label>

        <div style={S.footer}>
          <button style={S.btnGhost} onClick={onClose}>Cancelar</button>
          <button style={S.btnPrimary} onClick={submit} disabled={saving || !label.trim()}>
            {saving ? 'Salvando…' : 'Salvar template'}
          </button>
        </div>
      </div>
    </div>
  )
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(16,24,40,.35)', zIndex: 1300,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  box: {
    width: 520, maxWidth: '100%', background: 'var(--surface)', border: '1px solid #eaecf0',
    borderRadius: 14, padding: 20, boxShadow: '0 24px 48px rgba(16,24,40,.24)',
    display: 'flex', flexDirection: 'column', gap: 10,
  },
  head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  title: { margin: 0, fontSize: 17, fontWeight: 700, color: '#101828' },
  x: { border: 'none', background: 'transparent', width: 28, height: 28, borderRadius: 8, cursor: 'pointer', color: '#667085', fontSize: 20, lineHeight: 1 },
  miniLabel: { display: 'block', fontSize: 13, fontWeight: 500, color: '#344054', marginBottom: 6, marginTop: 8 },
  input: {
    width: '100%', boxSizing: 'border-box', height: 38, padding: '0 12px', borderRadius: 8,
    border: '1px solid #d0d5dd', background: 'var(--surface)', color: '#101828', fontSize: 13, fontFamily: 'inherit',
  },
  checkRow: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#344054', marginTop: 6 },
  checkbox: { width: 16, height: 16, accentColor: '#2563eb', cursor: 'pointer', margin: 0 },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14, paddingTop: 14, borderTop: '1px solid #eaecf0' },
  btnPrimary: {
    display: 'inline-flex', alignItems: 'center', gap: 8, height: 38, padding: '0 14px', borderRadius: 8,
    border: '1px solid var(--blue)', background: 'var(--blue)', color: '#fff',
    fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
  },
  btnGhost: {
    display: 'inline-flex', alignItems: 'center', gap: 8, height: 38, padding: '0 14px', borderRadius: 8,
    border: '1px solid #d0d5dd', background: 'var(--surface)', color: '#344054',
    fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
  },
  error: {
    padding: '10px 14px', borderRadius: 10, background: '#fef6f5',
    border: '1px solid #fbd9d3', color: '#b42318', fontSize: 13,
  },
}
